export const SEARCH = 'search';
export const REVERSE = 'reverse';
